import { ObjectId } from '@freightview/object-id'
import { isNil } from 'lodash-es'

function isObjectIdLike(obj: unknown): boolean {
  // We don't want string representations to be considered ObjectIds
  if (!obj || typeof obj !== 'object') {
    return false
  }

  return ObjectId.isValid(obj as any)
}

function isKnownObject(obj: any) {
  return obj instanceof Date || isObjectIdLike(obj)
}

function isObject(obj: any) {
  return typeof obj === 'object'
}
function isNotNull(obj: any) {
  return obj !== null
}

export function removeUndef<T>(obj: T, removeNull = false): T {
  if (isKnownObject(obj)) return obj

  if (isObject(obj) && isNotNull(obj)) {
    const entries = Object.entries(obj)
    const noUndef = entries
      .map(([k, v]) => {
        const newVal = removeUndef(v)
        return [k, newVal]
      })
      .filter(([, v]) => v !== undefined && (!removeNull || v !== null))
    let newObj = Object.fromEntries(noUndef)
    if (Array.isArray(obj)) newObj = Object.values(newObj)
    return newObj
  }
  return obj
}

export function removeNilOrEmpty<T>(obj: T): T {
  if (isKnownObject(obj)) return obj

  if (Array.isArray(obj)) {
    return obj.map(v => removeNilOrEmpty(v)) as T
  }

  if (isObject(obj) && isNotNull(obj)) {
    const entries = Object.entries(obj).map(([k, v]) => [
      k,
      removeNilOrEmpty(v),
    ])
    const noNil = entries.filter(
      ([, v]) => !isNil(v) && v !== '' && !(Array.isArray(v) && v.length === 0),
    )
    return Object.fromEntries(noNil)
  }
  return obj
}
